import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { useHelpDrawerStore } from '@/stores/useHelpDrawerStore'

/**
 * Synchronise la clé d'aide de la page courante avec la route.
 *
 * Clé = `route.meta.helpKey` si défini, sinon `route.name`. Le bouton d'aide
 * (présent dans `Bs2Title` et les en-têtes câblés) s'affiche automatiquement
 * dès qu'un fichier `docs/help/<clé>.user.md` (ou `.dev.md`) existe.
 *
 * À appeler **une seule fois**, dans `App.vue` (couvre les shells V1 et V2).
 */
export function useHelpRouteSync() {
  const route = useRoute()
  const store = useHelpDrawerStore()

  watch(
    () => [route.name, route.meta?.helpKey] as const,
    () => {
      const metaKey = route.meta?.helpKey
      const key =
        typeof metaKey === 'string'
          ? metaKey
          : typeof route.name === 'string'
            ? route.name
            : null
      store.setPageKey(key)
    },
    { immediate: true },
  )
}
